// extracted by mini-css-extract-plugin
export default {"header":"Header_header__F5X6S","main-image":"Header_main-image__uznzh"};